import type { RequestMiddleware } from './gqlEngineUtils';
import { ObjectSelection, getObjectSelection } from './gqlObjectSelection';

const X_FIELDS_HEADER = `X-Fields`;

export const objectSelectionToXFields = (objectSelection: ObjectSelection): string => {
	return Object.entries(objectSelection)
		.reduce((acc, [fieldName, selection]) => {
			if (selection) {
				acc.push(`${fieldName}(${objectSelectionToXFields(selection)})`);
			} else {
				acc.push(fieldName);
			}
			return acc;
		}, [] as string[])
		.join(`,`);
};

export const xFieldsRequestMiddleware: RequestMiddleware = (next) => (request) => {
	const objectSelection = getObjectSelection(request.info, request.context.variables);
	if (!objectSelection) return next(request);
	const xFields = objectSelectionToXFields(objectSelection);
	const {
		groupedVariables: { header, ...otherGroupedVariables },
		...otherRequest
	} = request;
	return next({
		...otherRequest,
		groupedVariables: {
			header: { ...header, [X_FIELDS_HEADER]: xFields },
			...otherGroupedVariables,
		},
	});
};
